'use client'
import { t as systemText } from '../i18n';

export default function GlobalError({ error, reset }) {
  return (
    <html>
      <body>
        <div className="min-h-screen flex items-center justify-center bg-surface-page">
          <div className="max-w-md w-full bg-surface-card shadow-md rounded-lg p-6">
            <h1 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">{systemText("Something went wrong!")}</h1>
            <p className="text-fg-tertiary mb-4">
              {error?.message || systemText("An unexpected error occurred.")}
            </p>
            <div className="space-y-2">
              <button
                onClick={() => reset()}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
              >
                {systemText("Try again")}
              </button>
              <button
                onClick={() => window.location.href = '/'}
                className="w-full bg-surface-strong hover:bg-gray-400 text-fg-strong px-4 py-2 rounded transition-colors"
              >
                {systemText("Go home")}
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && (
              <details className="mt-4">
                <summary className="cursor-pointer text-sm text-fg-muted">{systemText("Error details")}</summary>
                <pre className="mt-2 text-xs bg-surface-muted p-2 rounded overflow-auto">
                  {error?.stack}
                </pre>
              </details>
            )}
          </div>
        </div>
      </body>
    </html>
  )
}